// extracted by mini-css-extract-plugin
export default {"lightPanel":"TaskGrid_lightPanel__NduAF","darkPanel":"TaskGrid_darkPanel__qb8tI","title":"TaskGrid_title__KAlRX","modeToggle":"TaskGrid_modeToggle__U7aY2"};